import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Maps-Navigation / Pins / pin"
}, React.createElement("g", {
  fill: "none",
  stroke: "#808f9a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "data-name": "Group 44"
}, React.createElement("path", {
  "data-name": "Shape 137",
  d: "M8 .5A7.5 7.5 0 0 1 15.5 8c0 3.547-5.5 12.381-7.079 14.85a.5.5 0 0 1-.842 0C6 20.382.5 11.55.5 8A7.5 7.5 0 0 1 8 .5z"
}), React.createElement("path", {
  "data-name": "Oval 34",
  d: "M8 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3z"
})));

var SvgNavigation = function SvgNavigation() {
  return _ref;
};

export default SvgNavigation;